import { render, staticRenderFns } from "./DATextAreaPrimary.vue?vue&type=template&id=dd4e83e0"
import script from "./DATextAreaPrimary.vue?vue&type=script&lang=js"
export * from "./DATextAreaPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports